import FeaturedResource from './FeaturedResource';

export default FeaturedResource;
